import { Scatter } from 'vue-chartjs';
import ChartAnnotationsPlugin from 'chartjs-plugin-annotation';

export default {
    extends: Scatter,
    name: 'ScatterChart',
    props: {
        chartdata: {
            type: Object,
            default: null
        },
        options: {
            type: Object,
            default: null
        }
    },
    mounted () {
        // console.log('TC: mounted')
//        this.addPlugin(ChartAnnotationsPlugin);
        

 
//        this.renderChart (this.chartdata, this.options)
        
        this.addPlugin(ChartAnnotationsPlugin);
        
        var newOptions = JSON.parse(JSON.stringify(this.options));
        newOptions.scales.yAxes[0].ticks.callback = this.options.scales.yAxes[0].ticks.callback;
        newOptions.scales.xAxes[0].ticks.callback = this.options.scales.xAxes[0].ticks.callback;
        // console.log(newOptions);
        this.renderChart (this.chartdata, newOptions);
        
    }
}
